import { combineReducers } from 'redux'
import router from './router'
import navigation from './navigation'
import auth from './auth'
import userManagement from './user-management'
import documentation from './documentation'
import errorStats from './error-statistics'
import versionManagement from './version-management'
import customerManagement from './customer-management'
import licenceManagement from './licence-management'
import permissionsManagement from './permissions-management'
import { history } from 'redux-middleware/history'

export default combineReducers({
  auth,
  userManagement,
  navigation,
  documentation,
  errorStats,
  versionManagement,
  customerManagement,
  licenceManagement,
  permissionsManagement,
  router: router(history)
})
